import { DragSortTable } from '@ant-design/pro-components';
import './QMSTable.css';

const QMSTable = ({
  title,
  columns,
  onDragSortEnd,
  fullHeight,
  ...rest
}: {
  title: string;
  columns: any[];
  onDragSortEnd?: () => void;
  fullHeight?: boolean;
  dataSource?: any[];
}) => {
  const height = fullHeight ? window.innerHeight - 210 : 500;
  return (
    <div className="qms-table relative">
      <div className="rounded-t-lg bg-blue-700 p-2 text-center text-2xl font-bold text-white flex justify-center items-center">
        <span className="text-white">{title}</span>
        <span className="ml-2 rounded-full bg-blue-800 w-6 h-6 flex items-center justify-center text-white text-lg">{rest?.dataSource?.length || 0}</span>
      </div>
      <DragSortTable
        className={`rounded-b-xl max-h-[${height}px] min-h-[190px]`}
        columns={columns}
        dragSortKey="sort"
        pagination={false}
        rowKey="patient_id"
        search={false}
        showSorterTooltip={false}
        size="small"
        style={{ boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)', maxHeight: `${height}px` }}
        toolBarRender={false}
        onDragSortEnd={onDragSortEnd}
        scroll={{ y: height - 50 }}
        {...rest}
      />
    </div>
  );
};

export default QMSTable;
